<template>
  <div class="" style="margin-top:20px">
    <div class="">
      <!-- 查询区域 start -->
      <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="true"
        v-show="showSearch"
        label-width="68px"
      >
        <el-form-item prop="entpName" style="margin-right:0">
          <el-input
            v-model="queryParams.entpName"
            placeholder="培训学校名称"
            clearable
            :style="{ width: '200px' }"
            @keyup.enter.native="handleQuery"
          ></el-input>
        </el-form-item>
        <el-form-item prop="courseName" style="margin-right:0">
          <el-input
            v-model="queryParams.courseName"
            placeholder="课程名称"
            clearable
            :style="{ width: '200px' }"
            @keyup.enter.native="handleQuery"
          ></el-input>
        </el-form-item>
        <el-form-item prop="overStatus" style="margin-right:0">
          <el-select
            v-model="queryParams.overStatus"
            placeholder="请选择学习状态"
            clearable
          >
            <el-option
              v-for="(item, index) in overStatusOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQuery"
            >搜 索</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 start -->
    <div>
      <el-table v-loading="loading" :data="recordList">
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column
          label="员工姓名"
          prop="empName"
          align="center"
          width="150"
        />
        <el-table-column
          label="培训学校"
          prop="entpName"
          align="center"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="课程名称"
          prop="courseName"
          align="center"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="总学时"
          prop="courseTotal"
          align="center"
          width="70"
        />
         <el-table-column
          label="已完成学时"
          prop="studyCount"
          align="center"
          width="100"
        />

        <el-table-column
          label="完成状态"
          prop="courseOver"
          align="center"
          width="86"
          :formatter="overStatusFormatter"
        />
        <el-table-column
          label="完成时间"
          prop="courseFinishTime"
          align="center"
          width="160"
        />
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleView(scope.row)"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <!-- 表格 end -->
    <!-- 培训记录详情对话框 -->
    <el-dialog
      title="培训记录详情"
      :visible.sync="open"
      width="800px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-table :data="recordDetails" height="100%" border>
        <el-table-column type="index" label="序号" width="50" align="center" />
        <el-table-column
          label="章节名称"
          prop="ccName"
          align="center"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="学习状态"
          prop="courseOver"
          align="center"
          width="86"
          :formatter="overStatusFormatter2"
        />
        <el-table-column
          label="完成时间"
          prop="ccidStudyEnd"
          align="center"
          width="160"
        />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  getBizCourseRecord,
  getBizCourseRecordDetail,
} from "@/apiCloud/studyCentre";

export default {
  name: "TrainRecordNew",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 培训记录表格数据
      recordList: [],
      // 培训记录详情列表
      recordDetails: [],
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        entpName: undefined,
        courseName: undefined,
        overStatus: undefined,
      },
      // 多选选项
      overStatusOptions: [
        {
          label: "未学习",
          value: "0",
          raw: {
            listClass: "info",
          },
        },
        {
          label: "已学完",
          value: "1",
          raw: {
            listClass: "success",
          },
        },
        {
          label: "学习中",
          value: "2",
          raw: {
            listClass: "warning",
          },
        },
        {
          label: "未分课",
          value: "3",
          raw: {
            listClass: "info",
          },
        },
        {
          label: "已作废",
          value: "4",
          raw: {
            listClass: "danger",
          },
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    overStatusFormatter(row) {
      // return row.overStatus == 1 ? "已学完" : "未学习"
      if (row.courseOver == 0) {
        return "未学习";
      }
      if (row.courseOver == 1) {
        return "已学完";
      }
      if (row.courseOver == 2) {
        return "学习中";
      }
      if (row.courseOver == 3) {
        return "未分课";
      }
      if (row.courseOver == 4) {
        return "已作废";
      }
    },
    overStatusFormatter2(row) {
      // return row.overStatus == 1 ? "已学完" : "未学习"
      if (row.courseOver == 0) {
        return "学习中";
      }else if(row.courseOver == 1){
        return "已学完";
        
      }else{
        return '未学习'
      }
     
    },
    /** 查询培训记录信息列表 */
    getList() {
      this.loading = true;
      getBizCourseRecord(this.queryParams).then((response) => {
        this.recordList = response.rows;
        this.total = response.total;
        this.loading = false;
        this.$emit('changeRequestObj')
      });
    },
    // 表单重置
    reset() {
      this.recordDetails = [];
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 查看按钮操作 */
    handleView(row) {
      this.reset();
      const data = {
        singleCourseId: row.singleCourseId,
      };
      getBizCourseRecordDetail(data).then((res) => {
        this.recordDetails = res.rows;
        this.open = true;
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/studyCentre/components/TrainRecordNew/index.vue